/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookSenderDataRequestSchema = z.object({
	chatId: z.string().min(1),
	senderPhoneNumber: z.string().min(1).nullish(),
});
